import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faHome, faCaretDown, faArrowLeft, faArrowRight, faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import '../styles/Header.css'; // Add styles here
import logo from '../assets/logo192.png'; // Import the logo
import NotificationDropdown from './NotificationDropdown';
import MessageDropdown from './Messages/MessageDropdown';

// Roles whose landing page (/) is the doctor visit dashboard
const LANDING_DASHBOARD_ROLES = ['Doctor', 'Medical Director'];
// Roles that can open the doctor visit dashboard from the header icon
const DASHBOARD_ROLES = [...LANDING_DASHBOARD_ROLES, 'Admin'];

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const hasDashboard = DASHBOARD_ROLES.includes(user?.role);
  const dashboardPath = LANDING_DASHBOARD_ROLES.includes(user?.role) ? '/' : '/doctor-dashboard';

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
        <div className="environment-badge">
          {process.env.REACT_APP_ENVIRONMENT?.toUpperCase() || 'DEVELOPMENT'}
        </div>
      </div>
      <div className="nav-buttons">
        <button
          className="nav-button"
          onClick={() => navigate(-1)}
          title="Go Back"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <button
          className="nav-button"
          onClick={() => navigate(1)}
          title="Go Forward"
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
      <div className="user-menu">
        <Link to="/home" className="home-icon" title="Home">
          <FontAwesomeIcon icon={faHome} size="lg" />
        </Link>
        {hasDashboard && (
          <Link to={dashboardPath} className="dashboard-icon" title="Dashboard">
            <FontAwesomeIcon icon={faTachometerAlt} size="lg" />
          </Link>
        )}
        <NotificationDropdown />
        <MessageDropdown />
        <div className="user-info" onClick={handleDropdownToggle}>
          <span>{user?.name}</span>
          <FontAwesomeIcon icon={faUser} size="lg" className="account-icon" />
          <FontAwesomeIcon icon={faCaretDown} size="lg" />
        </div>
        <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
          <Link to="/home" onClick={() => setDropdownOpen(false)}>Home</Link>
          {hasDashboard && <Link to={dashboardPath} onClick={() => setDropdownOpen(false)}>Dashboard</Link>}
          <Link to="/account" onClick={() => setDropdownOpen(false)}>Account</Link>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
